export enum WebsocketSendActions {
  SUBSCRIBE = "subscribeChannel",
  UNSUBSCRIBE = "unsubscribeChannel",
  MESSAGE = "sendMessage",
}

export type IWebsocketSendBody =
  | {
      action: WebsocketSendActions.SUBSCRIBE | WebsocketSendActions.UNSUBSCRIBE;
      channel: string;
    }
  | {
      action: WebsocketSendActions.MESSAGE;
    };
